<template>
  <div class="body">
    <div class="title">
      消费详情
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item class="dsadf" :to="{ path: '/xiaofeijilu' }">消费记录</el-breadcrumb-item>
          <el-breadcrumb-item>查看详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <el-card  class="cardpsad">
      <el-row>
        <el-col :span="12">
          <div class="fromdsadas">
            <div class="tiile">
              基本信息
            </div>
            <div>
              <el-form class="demo-form-inline" :label-position="labelPosition" >
                <el-form-item label="消费用户" label-width="116px">
                  消费用户
                </el-form-item>
                <el-form-item label="姓名" label-width="116px">
                  姓名
                </el-form-item>
                <el-form-item label="消费金额/元" label-width="116px">
                  消费金额/元
                </el-form-item>
                <el-form-item label="消费类型" label-width="116px">
                  消费类型
                </el-form-item>
                <el-form-item label="余额/元" label-width="116px">
                  余额/元
                </el-form-item>
                <el-form-item label="总消费/元" label-width="116px">
                  总消费/元
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="fromdsadas">
            <div class="tiile">
              状态信息
            </div>
            <el-form class="demo-form-inline" :label-position="labelPosition">
              <el-form-item label="消费订单号 " label-width="116px">
                消费订单号
              </el-form-item>
              <el-form-item label="创建时间" label-width="116px">
                创建时间
              </el-form-item>
              <el-form-item label="交易状态" label-width="116px">
                创建时间
              </el-form-item>
              <el-form-item label="支付方式" label-width="116px">
                支付方式
              </el-form-item>
              <el-form-item label="交易订单号" label-width="116px">
                交易订单号
              </el-form-item>
              <el-form-item label="支付时间" label-width="116px">
                支付时间
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      labelPosition: 'left'
    }
  }
}
</script>
<style scoped lang="less">
.body {
  display: flex;
  flex-direction: column;
  .flexbox{
    display:flex;
    flex-direction: row;
    align-items: center;
  }
  .cardpsad{
    padding:40px 50px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
  }
  .wenbenyu{
    width: 370px;
  }
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3D9AFF;
    }

  }
  .fromdsadas{
    display:flex;
    flex-direction: column;
    .tiile{
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Heavy;
      font-weight: 800;
      text-align: left;
      color: #2e2e2e;
      letter-spacing: 0px;
      margin-bottom: 42px;
    }
  }
}
</style>
